import React from 'react';
import { AlertCircle } from 'lucide-react';
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <div className="text-center mb-12" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-100">
            DÉJAME HACERTE UNA PREGUNTA HONESTA…
          </h2>
          <div className="w-24 h-1 bg-violet-600 mx-auto mb-8" data-id="element-101" />
        </div>

        <div className="grid gap-8 mb-12" data-id="element-102">
          <div className="bg-violet-50 p-6 md:p-8 rounded-2xl border-l-4 border-violet-600 shadow-sm" data-id="element-103">
            <p className="text-xl md:text-2xl text-gray-800 font-medium italic leading-relaxed" data-id="element-104">
              "¿Sientes que esa persona se alejó sin una razón clara? ¿Notas que
              ya no te habla igual, que algo cambió… o que hay una tercera
              persona de por medio?"
            </p>
          </div>

          <div className="bg-violet-50 p-6 md:p-8 rounded-2xl border-l-4 border-violet-600 shadow-sm" data-id="element-105">
            <p className="text-xl md:text-2xl text-gray-800 font-medium italic leading-relaxed" data-id="element-106">
              "¿Intentaste explicar, insistir o acercarte… y todo empeoró?"
            </p>
          </div>
        </div>

        <div className="space-y-8" data-id="element-107">
          <h3 className="text-2xl font-bold text-gray-900 text-center" data-id="element-108">
            Tal vez hoy:
          </h3>

          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-109">
            {['Piensas en esa persona todos los días', 'Te duele verla(o) seguir con su vida', 'Sientes un vacío constante en el pecho', 'Intuyes que aún existe una conexión… pero algo la bloquea'].map((item, index) => <li key={index} className="flex items-start gap-4 p-4 bg-white border border-violet-100 rounded-lg shadow-sm" data-id="element-110">
                <AlertCircle className="w-6 h-6 text-violet-600 flex-shrink-0 mt-0.5" data-id="element-111" />
                <span className="text-lg text-gray-700" data-id="element-112">{item}</span>
              </li>)}
          </ul>

          <div className="text-center pt-8" data-id="element-113">
            <p className="text-xl md:text-2xl font-bold text-gray-800 bg-rose-50 inline-block px-6 py-3 rounded-full border border-rose-200" data-id="element-114">
              👉 No estás exagerando. No estás loc@. Y no estás sol@.
            </p>
          </div>
        </div>
      </div>
    </section>;
}